import { Routes, Route, Navigate } from "react-router-dom";
import React from "react";
import { route } from "./route";

import Home from "./../pages/home";

import Search from "../pages/search";

import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import IDFind from "../pages/auth/idFind";
import IDFindComplete from "../pages/auth/idFindComplete";
import PWFind from "../pages/auth/pwFind";
import PWChange from "../pages/auth/pwChange";

import StudyList from "../pages/study/studyList";

import LectureList from "../pages/lecture/lectureList";
import LectureDetail from "../pages/lecture/lectureDetail";
import LectureOnboardingComplete from "../pages/lecture/lectureOnboardingComplete";
import LecturePayment from "../pages/lecture/lecturePayment";
import LecturePaymentComplete from "../pages/lecture/lecturePaymentComplete";
import LecturePaymentFail from "../pages/lecture/lecturePaymentFail";

import ColumnList from "../pages/column/columnList";
import ColumnDetail from "../pages/column/columnDetail";

import MyPageSetting from "../pages/myPage/myPageSetting";
import MyPageSettingWithdrawal from "../pages/myPage/myPageSettingWithdrawal";
import MyPageActivity from "./../pages/myPage/myPageActivity";
import MyPageActivityComment from "./../pages/myPage/myPageActivityComment";
import MyPageActivityReview from "./../pages/myPage/myPageActivityReview";
import MyPageActivityReviewEdit from "./../pages/myPage/myPageActivityReviewEdit";
import MyPageActivityCoupon from "./../pages/myPage/myPageActivityCoupon";
import MyPageClassroom from "./../pages/myPage/myPageClassroom";
import MyPageClassroomComplete from "./../pages/myPage/myPageClassroomComplete";
import MyPageClassroomLecture from "./../pages/myPage/myPageClassroomLecture";
import MyPageClassroomReview from "./../pages/myPage/myPageClassroomReview";
import MyPageScrap from "./../pages/myPage/myPageScrap";
import MyPageScrapColumn from "./../pages/myPage/myPageScrapColumn";
import MyPagePayment from "./../pages/myPage/myPagePayment";
import MyPagePaymentSubscribe from "./../pages/myPage/myPagePaymentSubscribe";
import MyPagePaymentHistory from "./../pages/myPage/myPagePaymentHistory";
import MyPagePaymentRefund from "./../pages/myPage/myPagePaymentRefund";
import MyPagePaymentDetail from "./../pages/myPage/myPagePaymentDetail";
import CommunityList from "../pages/community/communityList";
import CommunityCreate from "../pages/community/communityCreate";
import CommunityDetail from "../pages/community/communityDetail";
import CustomerServiceNotice from "./../pages/customerService/customerServiceNotice";
import CustomerServiceFaq from "./../pages/customerService/customerServiceFaq";
import CustomerServiceTermsUse from "./../pages/customerService/customerServiceTermsUse";
import CustomerServiceTermsPrivacy from "./../pages/customerService/customerServiceTermsPrivacy";
import CustomerServiceAsk from "./../pages/customerService/customerServiceAsk";
import CustomerServiceAskDetail from "../pages/customerService/customerServiceAskDetail";
import CustomerServiceAskWrite from "./../pages/customerService/customerServiceAskWrite";
import CustomerServiceAskEdit from "./../pages/customerService/customerServiceAskEdit";
import Consulting from "./../pages/consulting/consulting";
import ConsultingPrior from "./../pages/consulting/consultingPrior";
import ConsultingPriorDetail from "./../pages/consulting/consultingPriorDetail";
import ConsultingApply from "./../pages/consulting/consultingApply";
import ConsultingProgress from "./../pages/consulting/consultingProgress";
import CustomerServiceAskMy from "./../pages/customerService/customerServiceAskMy";
import ConsultingProgressDetail from "./../pages/consulting/consultingProgressDetail";
import CommunityEdit from "../pages/community/communityEdit";
import ConsultingDetail from "../pages/consulting/consultingDetail";
import ConsultingPayment from "../pages/consulting/consultingPayment";

const Router = () => {
  return (
    <Routes>
      {/* default */}
      <Route path={route.default} element={<Home />} />

      {/* 홈 */}
      <Route path={route.home} element={<Home />} />

      {/* 검색 */}
      <Route path={route.search} element={<Search />} />
      <Route path={route.search + "/:legacyPage"} element={<Search />} />

      {/* auth */}
      <Route path={route.login} element={<Login />} />

      <Route path={route.register} element={<Register />} />
      <Route path={route.id_find} element={<IDFind />} />
      <Route path={route.id_find_complete} element={<IDFindComplete />} />
      <Route path={route.pw_find} element={<PWFind />} />
      <Route path={route.pw_change} element={<PWChange />} />

      {/* 금융 스터디 */}
      <Route path={route.study_list} element={<StudyList />} />

      {/* 영상 강의 */}
      <Route path={route.lecture_list} element={<LectureList />} />
      <Route path={`${route.lecture_detail}/:id`} element={<LectureDetail />} />
      <Route
        path={route.lecture_onboarding_complete}
        element={<LectureOnboardingComplete />}
      />
      <Route
        path={`${route.lecture_payment}/:id`}
        element={<LecturePayment />}
      />
      <Route
        path={route.lecture_payment_complete}
        element={<LecturePaymentComplete />}
      />
      <Route
        path={route.lecture_payment_fail}
        element={<LecturePaymentFail />}
      />

      {/* 금융 칼럼 */}
      <Route path={route.column_list} element={<ColumnList />} />
      <Route path={`${route.column_detail}/:id`} element={<ColumnDetail />} />

      {/* 커뮤니티 */}
      <Route path={route.community_list} element={<CommunityList />} />

      <Route path={`${route.community_create}`} element={<CommunityCreate />} />
      <Route path={`${route.community_edit}/:id`} element={<CommunityEdit />} />
      <Route
        path={`${route.community_detail}/:id`}
        element={<CommunityDetail />}
      />

      {/* 1:1 컨설팅 */}
      <Route path={route.consulting} element={<Consulting />} />
      <Route path={route.consulting_prior} element={<ConsultingPrior />} />
      <Route
        path={route.consulting_prior_detail + "/:id"}
        element={<ConsultingPriorDetail />}
      />
      <Route path={route.consulting_apply} element={<ConsultingApply />} />
      <Route
        path={route.consulting_progress}
        element={<ConsultingProgress />}
      />
      <Route
        path={route.consulting_progress_detail + "/:id"}
        element={<ConsultingProgressDetail />}
      />
      <Route
        path={`${route.consulting_detail}/:id`}
        element={<ConsultingDetail />}
      />
      <Route
        path={`${route.consulting_payment}/:id`}
        element={<ConsultingPayment />}
      />
      {/* 고객센터 */}
      <Route
        path={route.customer_service_notice}
        element={<CustomerServiceNotice />}
      />
      <Route
        path={route.customer_service_ask}
        element={<CustomerServiceAsk />}
      />
      <Route
        path={route.customer_service_ask_my}
        element={<CustomerServiceAskMy />}
      />
      <Route
        path={route.customer_service_ask_detail + "/:id"}
        element={<CustomerServiceAskDetail />}
      />
      <Route
        path={route.customer_service_ask_edit + "/:id"}
        element={<CustomerServiceAskEdit />}
      />
      <Route
        path={route.customer_service_ask_write}
        element={<CustomerServiceAskWrite />}
      />
      <Route
        path={route.customer_service_faq}
        element={<CustomerServiceFaq />}
      />
      <Route
        path={route.customer_service_terms_use}
        element={<CustomerServiceTermsUse />}
      />
      <Route
        path={route.customer_service_terms_privacy}
        element={<CustomerServiceTermsPrivacy />}
      />

      {/* 마이 페이지 */}
      <Route path={route.my_page_setting} element={<MyPageSetting />} />
      <Route
        path={route.my_page_setting_withdrawal}
        element={<MyPageSettingWithdrawal />}
      />
      <Route path={route.my_page_activity} element={<MyPageActivity />} />
      <Route
        path={route.my_page_activity_comment}
        element={<MyPageActivityComment />}
      />
      <Route
        path={route.my_page_activity_review}
        element={<MyPageActivityReview />}
      />
      <Route
        path={route.my_page_activity_review_edit + "/:id"}
        element={<MyPageActivityReviewEdit />}
      />
      <Route
        path={route.my_page_activity_coupon}
        element={<MyPageActivityCoupon />}
      />
      <Route path={route.my_page_classroom} element={<MyPageClassroom />} />
      <Route
        path={route.my_page_classroom_complete}
        element={<MyPageClassroomComplete />}
      />
      <Route
        path={`${route.my_page_classroom_lecture}/:memberLectureId/:id`}
        element={<MyPageClassroomLecture />}
      />
      <Route
        path={`${route.my_page_classroom_review}/:memberLectureId/:id`}
        element={<MyPageClassroomReview />}
      />
      <Route path={route.my_page_scrap} element={<MyPageScrap />} />
      <Route
        path={route.my_page_scrap_column}
        element={<MyPageScrapColumn />}
      />
      <Route path={route.my_page_payment} element={<MyPagePayment />} />
      <Route
        path={route.my_page_payment_subscribe}
        element={<MyPagePaymentSubscribe />}
      />
      <Route
        path={route.my_page_payment_history}
        element={<MyPagePaymentHistory />}
      />
      <Route
        path={route.my_page_payment_refund}
        element={<MyPagePaymentRefund />}
      />
      <Route
        path={route.my_page_payment_detail + "/:id"}
        element={<MyPagePaymentDetail />}
      />

      {/* Not Found */}
      <Route path="*" element={<Navigate to={route.default} replace />} />
    </Routes>
  );
};

export default Router;
